import propertyExpression from 'property-expr';

export class Validator {
    constructor(schema) {
        this.schema = schema;
        this.errors = new ErrorBag();
    }

    validate(data) {
        return this.schema.validate(data, {abortEarly: false})
            .then(x => {
                this.errors.clear();
                return true;
            })
            .catch(e => {
                this.errors.clear();
                for (const validationError of e.inner) {
                    this.errors.set(validationError.path, validationError.errors);
                }
                return false;
            })
    }

    validateField(field, value) {
        return this.schema.validateAt(field, value)
            .then(x => {
                this.errors.remove(field);
                return true;
            })
            .catch(e => {
                this.errors.remove(field);
                this.errors.set(e.path, e.errors);
                return false;
            });
    }
}

export class ErrorBag {
    constructor(errors = []) {
        this.errors = errors;
    }

    add(field, errors) {
        let currentErrors = this.get(field);
        if (!currentErrors) {
            currentErrors = [];
            this.errors.push({field, errors: currentErrors});
        }
        currentErrors.push(...(Array.isArray(errors) ? errors : [errors]));
    }

    set(field, errors) {
        const errorObject = this.errors.find(x => x.field === field);
        if (errorObject) {
            errorObject.errors = errors;
        } else {
            this.errors.push({field, errors});
        }
    }

    get(field) {
        const errorObject = this.errors.find(x => x.field === field);
        if (errorObject) {
            return errorObject.errors;
        }
    }

    has(field) {
        return !!this.get(field);
    }

    first(field) {
        const errors = this.get(field);
        if (errors) {
            return errors[0];
        }
    }

    getAllFirstForFields(...fields) {
        return [
            ...fields.map(field => this.first(field))
        ].filter(x => x);
    }

    getAllForPath(...path) {
        const normalizedPath = path.map(x => x + '');
        return new ErrorBag(
            this.errors.reduce((result, error) => {
                const parsedPath = propertyExpression.split(error.field);
                if (normalizedPath.every((x, index) => x === parsedPath[index])) {
                    return result.concat([
                        {field: parsedPath.slice(normalizedPath.length).join('.'), errors: error.errors}
                    ]);
                }
                return result;
            }, [])
        );
    }

    getPath(index, errors) {
        if(!!errors && errors.length > 0) {
            let _errors = errors[0];
            for (const item_index in _errors) {
                if (parseInt(index) === parseInt(item_index)) {
                    let _item = [];
                    for(index in _errors[item_index][0]) {
                        _item.push({
                            field: index,
                            errors: _errors[item_index][0][index]
                        })
                    }
                    return new ErrorBag(_item);
                }
            }
        }
        return new ErrorBag([]);
    }

    remove(field) {
        const index = this.errors.findIndex(x => x.field === field);
        if (index !== -1) {
            this.errors.splice(index, 1);
        }
    }

    count() {
        return this.errors.length;
    }

    clear() {
        this.errors.splice(0, this.errors.length);
    }

    hasAny() {
        return this.count() > 0;
    }
}